<template>
  <div class="user-water-trend">
    <div class="trend-chart">
      <Echart ref="trendChart" :options="chartOptions" style="height: 100%; width: 100%" />
    </div>
  </div>
</template>

<script>
import { putAction } from '@/api/manage'
import * as echarts from 'echarts'

export default {
  name: 'UserWaterTrend',
  data() {
    return {
      loading: false,
      chartOptions: {},
      months: [],
      waterTypeNames: [],
      waterUseList: [],
      url: {
        list: '/jeecg-charge/meter/waterAnalysis/waterTypeWaterUse'
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.queryUserWaterTrend()
    },
    queryUserWaterTrend() {
      this.loading = true
      putAction(this.url.list, {}).then((res) => {
        if(res.success){
          this.processWaterTypeData(res.result)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    processWaterTypeData(data) {
      if (!data) return
      
      this.months = data.monthStrList || []
      this.waterTypeNames = data.waterTypeNameList || []
      this.waterUseList = data.waterUseList || []
      
      this.generateChartOptions()
    },
    generateChartOptions() {
      const series = []
      const colors = [
        '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', '#DDA0DD',
        '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9', '#F8C471'
      ]
      
      // 为每个用水类型创建一个系列
      this.waterUseList.forEach((data, index) => {
        if (this.waterTypeNames[index]) {
          series.push({
            name: this.waterTypeNames[index],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: {
              width: 2,
              color: colors[index % colors.length]
            },
            itemStyle: {
              color: colors[index % colors.length],
              borderColor: '#fff',
              borderWidth: 1
            },
            data: data
          })
        }
      })

      this.chartOptions = {
        grid: {
          top: '15%',
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 11, 42, 0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF'
          },
          formatter: (params) => {
            let result = params[0].name + '<br/>'
            params.forEach(item => {
              if (item.value > 0) {
                result += `${item.marker}${item.seriesName}: ${item.value}m³<br/>`
              }
            })
            return result
          }
        },
        legend: {
          data: this.waterTypeNames.filter((_, index) => 
            this.waterUseList[index] && this.waterUseList[index].some(val => val > 0)
          ),
          textStyle: {
            color: '#CEE2FF',
            fontSize: 9
          },
          icon: 'circle',
          itemHeight: 8,
          type: 'scroll',
          orient: 'horizontal',
          bottom: 0
        },
        xAxis: {
          type: 'category',
          data: this.months,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('用水量(m³)'),
          nameTextStyle: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 10,
            padding: [0, 0, 0, 30]
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 10,
            formatter: '{value}m³'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: series
      }
    }
  }
}
</script>

<style lang="less" scoped>
.user-water-trend {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  
  .trend-header {
    margin-bottom: 0.75rem;
  }
  
  .trend-stats {
    display: flex;
    gap: 0.5rem;
    
    .stat-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.5rem;
      background: linear-gradient(135deg, rgba(78, 205, 196, 0.1), rgba(68, 160, 141, 0.1));
      border: 1px solid rgba(78, 205, 196, 0.2);
      border-radius: 6px;
      
      .stat-value {
        font-family: 'ds-digital-bold', monospace;
        font-size: 1.125rem;
        font-weight: bold;
        color: #4ECDC4;
        text-shadow: 0 0 8px rgba(78, 205, 196, 0.5);
        margin-bottom: 0.125rem;
      }
      
      .stat-label {
        font-size: 0.625rem;
        color: rgba(255, 255, 255, 0.7);
        text-align: center;
      }
    }
  }
  
  .trend-chart {
    flex: 1;
    min-height: 0;
  }
}

@media (max-width: 768px) {
  .user-water-trend {
    .trend-stats {
      gap: 0.25rem;
      
      .stat-item {
        padding: 0.375rem 0.25rem;
        
        .stat-value {
          font-size: 0.875rem;
        }
        
        .stat-label {
          font-size: 0.5rem;
        }
      }
    }
  }
}
</style>